const FriendsData = [
    {
      name:'Nazmus Sakib',
      age:25,
      email:'saakeeb752@gmail.com',
      mobile: '01921-652823',
      img:'https://i.ibb.co/W6FtLc0/129-225-copy-1.jpg',
      job:'Freelancer',
      income:13600,
      address: 'Narsingdi',
      zipCode: 1600,
      id:100001
    },
    {
        name:'Sadat Mohammad',
        age:15,
        email:'fakemail@gmail.com',
        mobile: '01921-652876',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRO3ViIRvfSVgksdSRZPEjdO3UepP4tfqUJ877HVbk3sUTetUCo&usqp=CAU',
        job:'Acting',
        income:12600,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100002
      },
      {
        name:'Aoin Chowdury',
        age:24,
        email:'fakemail@gmail.com',
        mobile: '01921-652890',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQmIOG-KBH54W3Fqb3G9R_ecNMNXR69e2DD7rUzkVds3E18xstD&usqp=CAU',
        job:'SR',
        income:13000,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100003
      },
      {
        name:'Zonayed Sarkar',
        age:26,
        email:'fakemail@gmail.com',
        mobile: '01921-234321',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRIO-mnIXDK0XwmRjUBK3t86YtL2XxHuevji_iFLUg78pwRO11O&usqp=CAU',
        job:'Teacher',
        income:13200,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100004
      },
      {
        name:'Siddikur Rahman',
        age:24,
        email:'fakemail@gmail.com',
        mobile: '01921-659873',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRO3ViIRvfSVgksdSRZPEjdO3UepP4tfqUJ877HVbk3sUTetUCo&usqp=CAU',
        job:'Consultant',
        income:13800,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100005
      },
      {
        name:'Mahbhub Sunny',
        age:25,
        email:'fakemail@gmail.com',
        mobile: '01921-676523',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQmIOG-KBH54W3Fqb3G9R_ecNMNXR69e2DD7rUzkVds3E18xstD&usqp=CAU',
        job:'Business man',
        income:14000,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100006
      },
      {
        name:'Robi Ullah',
        age:24,
        email:'fakemail@gmail.com',
        mobile: '01921-667543',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRIO-mnIXDK0XwmRjUBK3t86YtL2XxHuevji_iFLUg78pwRO11O&usqp=CAU',
        job:'Accountant',
        income:13500,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100007
      },
      {
        name:'Rahed Uz Zaman',
        age:26,
        email:'fakemail@gmail.com',
        mobile: '01921-612321',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRO3ViIRvfSVgksdSRZPEjdO3UepP4tfqUJ877HVbk3sUTetUCo&usqp=CAU',
        job:'Investor',
        income:14000,
        address: 'Dhaka',
        zipCode: 1600,
        id:100008
      },
      {
        name:'Ahmed Shahriar',
        age:26,
        email:'fakemail@gmail.com',
        mobile: '01921-098823',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQmIOG-KBH54W3Fqb3G9R_ecNMNXR69e2DD7rUzkVds3E18xstD&usqp=CAU',
        job:'Comedian',
        income: 13000,
        address: 'Rajshahi',
        zipCode: 1600,
        id:100009
      },
      {
        name:'Ashikul Islam',
        age:26,
        email:'fakemail@gmail.com',
        mobile: '01921-989098',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRIO-mnIXDK0XwmRjUBK3t86YtL2XxHuevji_iFLUg78pwRO11O&usqp=CAU',
        job:'Teacher',
        income:13000,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100010
      },
      {
        name:'Shibli Noman',
        age:25,
        email:'fakemail@gmail.com',
        mobile: '01921-652666',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRO3ViIRvfSVgksdSRZPEjdO3UepP4tfqUJ877HVbk3sUTetUCo&usqp=CAU',
        job:'Consultant',
        income:12800,
        address: 'Brahman Baria',
        zipCode: 1600,
        id:100011
      },
      {
        name:'Mohammad Sunny',
        age:27,
        email:'fakemail@gmail.com',
        mobile: '01921-653434',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQmIOG-KBH54W3Fqb3G9R_ecNMNXR69e2DD7rUzkVds3E18xstD&usqp=CAU',
        job:'Engineer',
        income:13800,
        address: 'BrahmanBaria',
        zipCode: 1600,
        id:100012
      },
      {
        name:'Sami Ullah',
        age:25,
        email:'fakemail@gmail.com',
        mobile: '01921-645654',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRIO-mnIXDK0XwmRjUBK3t86YtL2XxHuevji_iFLUg78pwRO11O&usqp=CAU',
        job:'Communication Tech',
        income:13300,
        address: 'Jaypurhat',
        zipCode: 1600,
        id:100013
      },
      {
        name:'Tarek hasan',
        age:25,
        email:'fakemail@gmail.com',
        mobile: '01921-652221',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRO3ViIRvfSVgksdSRZPEjdO3UepP4tfqUJ877HVbk3sUTetUCo&usqp=CAU',
        job:'Govt service',
        income:13000,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100014
      },
      {
        name:'Sheikh Roni',
        age:25,
        email:'fakemail@gmail.com',
        mobile: '01921-665561',
        img:'https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQmIOG-KBH54W3Fqb3G9R_ecNMNXR69e2DD7rUzkVds3E18xstD&usqp=CAU',
        job:'Political Chameleon',
        income:13600,
        address: 'Narsingdi',
        zipCode: 1600,
        id:100015
      }
]
  
export default FriendsData;